module.exports = "/images/arrow-drop-down.svg?a4834a128b5612a8c217a81071573d20";